var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSessionTypeAuto(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.131 11.8225L8.6142 11.3058L10.2691 9.65098C11.1803 8.73971 11.1803 7.26237 10.2691 6.35113L8.6142 4.69631L9.131 4.17956C9.78187 3.52869 10.8371 3.52869 11.488 4.17956L14.131 6.82251C14.7819 7.47344 14.7819 8.52871 14.131 9.17957L11.488 11.8225C10.8371 12.4734 9.78187 12.4734 9.131 11.8225ZM9.79767 9.17957C10.4485 8.52871 10.4485 7.47344 9.79767 6.82251L7.15467 4.17956C6.50379 3.52869 5.44851 3.52869 4.79763 4.17956L2.15466 6.82251C1.50379 7.47344 1.50379 8.52871 2.15466 9.17957L4.79763 11.8225C5.44851 12.4734 6.50379 12.4734 7.15467 11.8225L9.79767 9.17957Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionTypeAuto);
export default __webpack_public_path__ + "static/media/session-type-auto.7f40b6870f80450e23a93f1bc38d1711.svg";
export { ForwardRef as ReactComponent };